<template>
  <main-large-dialog
    :has-agree="false"
    :is-visible.sync="computedIsVisible"
    :title="dialogTitle"
    dialog-width="32%"
    disagreeText="dialog.close"
    no-paddings-x
    no-paddings-y
    header-shadow
    use-sticky-buttons
    min-body-height="60vh"
  >
    <template #body>
      <sidebar-module-info
        :filtered-attributes="['hydrant_id', 'id']"
        ref="sidebarModuleInfo"
        module-name="hydrants_inspections"
        permissions-path="HYDRANTS_INSPECTIONS"
        :has-assigned-objects="false"
        :custom-card-title="customCardTitle"
        :custom-current-object-id="currentInspectionId"
        :custom-parent-route="pushToHydrants"
        :handle-object-adding="handleHydrantInspectionAdding"
        :handle-object-deleting="handleHydrantInspectionDeleting"
        :handle-object-editing="handleHydrantInspectionEditing"
        sticky-cancel-translation="dialog.disagreeClose"
        :has-geometry="false"
        :has-new-objects="false"
        :has-title-row="true"
        :init-gets="initGets"
        :inputs="inputs"
        :is-modal="true"
        module-mapping-data-source-name="inspections_datasource_name"
        module-mapping-layer-name="inspections_layer_id"
        :module-objects="hydrantInspectionsAll"
        name-attribute="id"
        :toggle-object-adding="toggleHydrantInspectionAdding"
        :new-object-payload="newObjectPayload"
        has-basic-attributes
        has-custom-schema
        :custom-form-schema="currentLayerFormSchema"
        :customObjectExtrasTabs="['changeHistory', 'notes', 'attachments']"
        :printLayer="inspectionsLayer"
      />
    </template>
  </main-large-dialog>
</template>

<script>
import { call, get, sync } from 'vuex-pathify';

import SidebarModuleInfo from '@/components/SidebarModuleInfo';
import MainLargeDialog from '@/components/MainLargeDialog';

import defaultValues from '@/mixins/defaultValues';

export default {
  name: 'HydrantInspection',
  mixins: [defaultValues],
  components: {
    MainLargeDialog,
    SidebarModuleInfo,
  },
  props: {
    currentInspectionId: {
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    newObjectPayload: {},
  }),
  computed: {
    currentTab: sync('sidebar/currentTab'),
    currentLayerFormSchema: get('layers/layers@:inspectionsLayerId.form_schema'),
    currentHydrantInspection: get('hydrants/hydrantInspectionsAll@:currentObjectId'),
    dataSource: get('admin/modulesMapping@hydrants_inspections.inspections_datasource_name'),
    dataSourcesForms: get('layers/dataSourcesForms@:dataSource'),
    hydrantsLayerId: get('admin/modulesMapping@hydrants_inspections.hydrants_layer_id'),
    inspectionsLayerId: get('admin/modulesMapping@hydrants_inspections.inspections_layer_id'),
    hydrantInspectionsAll: get('hydrants/hydrantInspectionsAll'),
    layers: get('layers/layers'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    currentInspection: get('hydrants/hydrantInspectionsAll@:currentObjectId.hydrant_id'),
    currentHydrantId() {
      return this.$route.params.fid;
    },
    currentObjectId() {
      return this.currentInspectionId;
    },
    customCardTitle() {
      return {
        new: '',
        edit: this.$i18n.t('dialog.inspectionId', { id: this.currentInspectionId }),
      };
    },
    dialogTitle() {
      return this.currentObjectId !== 'new'
        ? this.$i18n.t('navbar.hydrantInspections')
        : this.$i18n.t('dialog.addNewInspection');
    },
    hydrantInspectionObject() {
      return this.currentObjectId
        ? { [this.currentObjectId]: [{ layer_id: this.hydrantsLayerId, object_id: this.currentInspection }] }
        : {};
    },
    inputs() {
      return {
        new: [],
        edit: [],
      };
    },
    inspectionsLayer() {
      return this.layers[this.inspectionsLayerId];
    },
  },
  watch: {
    computedIsVisible(nV) {
      if (!nV) {
        this.$refs.sidebarModuleInfo.hideEditObject();
      }
    },
  },
  methods: {
    addHydrantInspection: call('hydrants/addHydrantInspection'),
    deleteHydrantInspection: call('hydrants/deleteHydrantInspection'),
    editHydrantInspection: call('hydrants/editHydrantInspection'),
    getDataSourceForm: call('layers/getDataSourceForm'),
    getHydrantsInspections: call('hydrants/getHydrantsInspections'),
    getHydrantsInspectionsAll: call('hydrants/getHydrantsInspectionsAll'),
    pushToHydrant() {
      this.$router.push({
        name: 'layerFeature',
        params: {
          lid: this.hydrantsLayerId,
          fid: this.currentHydrantInspection.hydrant_id,
        },
      });
    },
    pushToHydrants() {
      if (this.currentHydrantInspection) {
        this.pushToHydrant();
        return;
      }
      this.$router.push({
        name: 'layerTable',
        params: {
          lid: this.hydrantsLayerId,
        },
      });
      this.currentTab = 0;
    },
    toggleHydrantInspectionAdding() {
      this.$router.push({
        name: 'hydrantInspection',
        params: { fid: 'new' },
      });
    },
    async handleHydrantInspectionAdding(payload) {
      const feature = {
        ...payload,
        hydrant_id: this.currentHydrantId,
      };
      const r = await this.addHydrantInspection(feature);
      this.$emit('refreshInspectionsList');
      return r.data.data;
    },
    async handleHydrantInspectionDeleting(id) {
      try {
        await this.deleteHydrantInspection(id);
        this.$emit('refreshInspectionsList');
        this.computedIsVisible = false;
      } catch {
        //
      }
    },
    async handleHydrantInspectionEditing(payload) {
      const inspection_id = payload.id;
      delete payload.id;
      const feature = {
        ...payload,
        hydrant_id: this.currentHydrantId,
      };
      await this.editHydrantInspection({ inspection_id, feature });
      this.$emit('refreshInspectionsList');
      this.$refs.sidebarModuleInfo.hideEditObject();
    },
    async initGets() {
      await this.getHydrantsInspectionsAll();
    },
  },
};
</script>
